import React from 'react';
import PropTypes from 'prop-types';
import './SelectableCard.css';

/**
 * SelectableCard Molecule - karta z możliwością wyboru (radio button)
 * Używana do wyboru opcji jak typ treści, źródło miniaturek, etc.
 */
const SelectableCard = ({
  id,
  title,
  description,
  icon: IconComponent,
  selected = false,
  disabled = false,
  hidden = false,
  comingSoon = false,
  onClick,
  className = '',
  ...props
}) => {
  if (hidden) return null;

  const cardClasses = [
    'choice-card',
    selected 
      ? 'choice-card--selected' 
      : 'choice-card--default',
    disabled && 'choice-card--disabled',
    className
  ].filter(Boolean).join(' ');

  const handleClick = () => {
    if (!disabled && onClick) {
      onClick(id);
    }
  };

  return (
    <div
      className={cardClasses}
      onClick={handleClick}
      title={comingSoon ? 'Coming Soon' : ''}
      {...props}
    >
      {/* Icon */}
      {IconComponent && (
        <div className="h-6 w-6 mb-4 text-neutral-900 rounded-full flex-shrink-0">
          <IconComponent />
        </div>
      )}
      
      {/* Content */}
      <div className="flex-1">
        <h3 className="text-base font-medium mb-1 flex items-center gap-2">
          {title}
          {comingSoon && (
            <span className="text-xs bg-blue-100 text-blue-700 px-2 py-1 rounded-full">
              Coming Soon
            </span>
          )}
        </h3>
        <p className="text-sm text-gray-600">{description}</p>
      </div>
    </div>
  );
};

SelectableCard.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  icon: PropTypes.elementType,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  hidden: PropTypes.bool,
  comingSoon: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string,
};

export default SelectableCard;
